import Swal from "sweetalert2";

export type ShowSuccessAlertProps = {
  text: string;
  onConfirm?: () => void;
};

export const ShowSuccessAlert = ({
  text,
  onConfirm,
}: ShowSuccessAlertProps) => {
  Swal.fire({
    icon: "success",
    title: "Success",
    text,
    confirmButtonColor: "var(--theme-default)",
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    }
  });
};
